import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../../lib/cn';

type Tone = 'neutral' | 'accent' | 'ink' | 'success' | 'warning' | 'destructive';

export interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: Tone;
  leftIcon?: ReactNode;
}

const tones: Record<Tone, string> = {
  neutral: 'bg-surface-2 text-fg',
  accent: 'bg-accent-soft text-accent-soft-on',
  ink: 'bg-ink text-ink-on',
  success: 'bg-success-subtle text-success',
  warning: 'bg-warning-subtle text-warning',
  destructive: 'bg-destructive-subtle text-destructive',
};

export function Badge({ tone = 'neutral', leftIcon, className, children, ...rest }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold',
        tones[tone],
        className,
      )}
      {...rest}
    >
      {leftIcon}
      {children}
    </span>
  );
}
